import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  franchiseAccounting: null,
  franchiseAccountings: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const franchiseAccountingReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.FRANCHISEACCOUNTING_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.FRANCHISEACCOUNTING_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.FRANCHISEACCOUNTING_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default franchiseAccountingReducer;
